var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.5C9.68555 0.5 6.50391 1.81777 4.16211 4.16113C1.8179 6.50542 0.500649 9.68473 0.5 13C0.5 16.3139 1.81836 19.4955 4.16211 21.8389C6.50391 24.1822 9.68555 25.5 13 25.5C16.3145 25.5 19.4961 24.1822 21.8379 21.8389C24.1816 19.4955 25.5 16.3139 25.5 13C25.5 9.68613 24.1816 6.50449 21.8379 4.16113C19.4961 1.81777 16.3145 0.5 13 0.5Z",
    fill: "url(#paint0_linear_2001_414)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1582 12.868C9.80273 11.2805 12.2324 10.2338 13.4473 9.72813C16.9199 8.28418 17.6406 8.0334 18.1113 8.0249C18.2148 8.02324 18.4453 8.04883 18.5957 8.17041C18.7207 8.27295 18.7559 8.41162 18.7734 8.50898C18.7891 8.60625 18.8105 8.82793 18.793 9.00098C18.6055 10.9775 17.791 15.774 17.377 17.9879C17.2031 18.9246 16.8574 19.2387 16.5234 19.2693C15.7969 19.3361 15.2461 18.7896 14.543 18.3289C13.4434 17.6076 12.8223 17.1588 11.7539 16.4551C10.5195 15.6418 11.3203 15.1947 12.0234 14.4643C12.207 14.273 15.4062 11.3639 15.4668 11.1C15.4746 11.067 15.4824 10.9439 15.4082 10.8791C15.3359 10.8141 15.2285 10.8363 15.1504 10.8539C15.0391 10.8789 13.2832 12.0406 9.87695 14.3389C9.37891 14.6814 8.92773 14.8484 8.52148 14.8396C8.07617 14.8301 7.2168 14.5873 6.57813 14.3799C5.79688 14.1254 5.17383 13.9908 5.22852 13.5586C5.25586 13.3336 5.56641 13.1033 6.1582 12.868Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2001_414",
    x1: 1250.5,
    y1: 0.5,
    x2: 1250.5,
    y2: 2500.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.cee78eea2f323d5355db844c9f65f840.svg";
export { ForwardRef as ReactComponent };